import { Component, h, Prop } from '@stencil/core';
import { hexToRgb } from './../../../utils/utils';
import state from './../../../state/store';

@Component({
  tag: 'afs-navbar',
  styleUrls: {
    'solid': './mode/afs-navbar-solid.sass',
    'gradient': './mode/afs-navbar-gradient.sass',
  },
  shadow: true,
})
export class AfsNavbar {

  @Prop() afsLogo : boolean = false;
  @Prop() imageTheme : 'light' | 'dark' | 'color' = "light";
  @Prop() height : number = 50;
  @Prop() backgroundColor : string = "#222222";
  @Prop() setNav : boolean = false;
  @Prop() gradientBackground : boolean = false;
  @Prop() logoHeight : number = 80;
  @Prop() logoHeightGradientDesktop : number = this.logoHeight / 2;
  @Prop() mode : 'solid' | 'gradient' = 'gradient';

  componentWillLoad() {
    state.navbarMode = this.mode;

    if (this.mode === 'solid')
      state.navHeight = this.height;
      state.navHeightForButton = this.height;

    if (this.mode === 'gradient')
      state.navHeightForButton = this.height * 2;
  }

  render() {
    const gradientRGB = hexToRgb(this.backgroundColor);

    return (
      <header class="header" style={{ 
        '--nav-height': `${this.height}px`,
        position: this.mode === 'gradient' ? 'absolute' : 'relative',
      }}>
        { this.mode !== 'gradient' && <div class="relative-placeholder"></div> }
        <div class="fixed-navbar" style={{ 
          background: this.mode === 'gradient' ? `linear-gradient(180deg, rgba(${gradientRGB.r},${gradientRGB.g},${gradientRGB.b},0.7) 0%, rgba(${gradientRGB.r},${gradientRGB.g},${gradientRGB.b},0) 100%)` : this.backgroundColor,
          boxShadow: this.mode === 'gradient' ? 'unset' : '0px 0px 1rem 0px rgba(0,0,0,0.2)',
          position: this.mode === 'gradient' ? 'unset' : 'fixed',
        }}>
          <div class="fixed-navbar-flex-wrapper">
            <div class="logobox" style={{ '--logo-height': `${this.logoHeight}%`, '--logo-height-desktop': `${this.logoHeightGradientDesktop}%` }}>
              <slot></slot>
            </div>
            { this.setNav || this.afsLogo ? <div class="right-container">
              { this.setNav && <slot name="nav"></slot> }
              { this.afsLogo && <div class="ascend-logobox" style={{ '--afs-logo-height': this.mode === 'gradient' ? '30%' : '60%' }}><afs-asset href="https://ascendfs.com" src={`logo/afs-logo-${this.imageTheme}.svg`} alt="Ascend Fundraising Solutions Logo" ratio-fit></afs-asset></div> }
            </div> : '' }
          </div>
        </div>
      </header>
    );
  }

}
